import {Group} from "react-konva";
import type Konva from "konva";
import type Combatant from "@/encounter/model/Combatant.ts";
import {useTurn} from "@/encounter/turns/TurnHooks.ts";
import {useRoundTokenInteraction} from "./RoundTokenInteractionHooks.ts";
import {RoundTokenAppearance} from "./RoundTokenAppearance.tsx";
import type {AreaEffectMark} from "@/tabletop/effects/AreaEffectHighlights.ts";

export type TokenProps = {
    combatant: Combatant;
    outsidePlayerSight?: boolean;
    areaEffectMarks?: AreaEffectMark[];
};

export function RoundToken({combatant, outsidePlayerSight = false, areaEffectMarks}: TokenProps) {
    const {isActiveCombatant} = useTurn();
    const {isSelected, handleMouseDown} = useRoundTokenInteraction(combatant);
    const handleContextMenu = (event: Konva.KonvaEventObject<MouseEvent>) => event.evt.preventDefault();
    // World position and mouse interaction; the individual visual elements are documented in RoundTokenAppearance.
    return <Group x={combatant.position.x} y={combatant.position.y}
        onContextMenu={handleContextMenu} onMouseDown={handleMouseDown}>
        <RoundTokenAppearance combatant={combatant} selected={isSelected}
            active={isActiveCombatant(combatant)} outsidePlayerSight={outsidePlayerSight} areaEffectMarks={areaEffectMarks}/>
    </Group>;
}
